export default __webpack_public_path__ + "static/Roboto-Medium-70ace3870f471997ceb71da78dcd9e13.woff2";